
import BasicCard from "../../pages/BasicCard";
import Dummylayout from "../../pages/Dummylayout";
import AnnouncementTable from "./AnnouncementTable";





function AnnouncementTableMain() {
    return (
        <>
            <Dummylayout/>
            <BasicCard>
                <AnnouncementTable/>
            </BasicCard>
        </>
    )
}
export default AnnouncementTableMain;